import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { Provider } from "react-redux"
import store from "./redux/store"
import { createRoot } from "react-dom/client"
import dayjs from "dayjs"

import weekOfYear from "dayjs/plugin/weekOfYear"
import isoWeek from "dayjs/plugin/isoWeek"

dayjs.extend(weekOfYear)
dayjs.extend(isoWeek)

const root = createRoot(document.getElementById("root"))

root.render(
  <Provider store={store}>
    <App />
  </Provider>
)

reportWebVitals()
